import { render, staticRenderFns } from "./CrearContrasena.vue?vue&type=template&id=ecb80c78&scoped=true&"
import script from "./CrearContrasena.vue?vue&type=script&lang=js&"
export * from "./CrearContrasena.vue?vue&type=script&lang=js&"
import style0 from "./CrearContrasena.vue?vue&type=style&index=0&id=ecb80c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb80c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
